import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M366-366H225q-16 0-28-11t-11-29q0-17 11-28 12-12 28-12h180q17 0 29 12 11 11 11 28v180q0 17-11 29-12 11-29 11t-28-11q-11-12-11-29v-140Zm229-229h140q16 0 28 12t12 29-12 28q-12 11-28 11H555q-17 0-29-11-11-12-11-29v-180q0-16 11-28 12-12 29-12t28 12q12 12 12 28v140Z"/>',
  f: '<path d="M366-366H225q-16 0-28-11t-11-29q0-17 11-28 12-12 28-12h180q17 0 29 12 11 11 11 28v180q0 17-11 29-12 11-29 11t-28-11q-11-12-11-29v-140Zm229-229h140q16 0 28 12t12 29-12 28q-12 11-28 11H555q-17 0-29-11-11-12-11-29v-180q0-16 11-28 12-12 29-12t28 12q12 12 12 28v140Z"/>',
};

export default data;
